import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { API_BASE } from '../api/config'

// Derive beacon URL from same CloudFront domain as API calls
const BEACON_URL = API_BASE.replace(/\/api$/, '/beacon')
const DWELL_TIME_MS = 2000

export function usePageViewBeacon(): void {
  const location = useLocation()

  useEffect(() => {
    if (typeof navigator.sendBeacon !== 'function') return

    const timerId = setTimeout(() => {
      const payload = JSON.stringify({
        path: location.pathname,
        timestamp: Date.now(),
      })

      navigator.sendBeacon(BEACON_URL, new Blob([payload], { type: 'application/json' }))
    }, DWELL_TIME_MS)

    return () => {
      clearTimeout(timerId)
    }
  }, [location.pathname])
}
